
import { ATTR_TYPES } from './dataDefinition.js';

const DEFINITION_OPSUB = {
    objectType: 'opsub',
    tableName: 'iskn_oprav_subjekty',
    title: 'Vlastníci',
    attributes: [
        {
            id: 'id',
            type: ATTR_TYPES.STRING,
            title: 'ID oprsub'
        },
        {
            id: 'name',
            type: ATTR_TYPES.STRING,
            title: 'Jméno / Název',
            sqlField: `lower(COALESCE(jmeno, '') || ' ' || COALESCE(prijmeni, '') || ' ' || COALESCE(nazev, ''))`,
            sqlWhere: `(lower(@FIELD@) LIKE lower('%@VALUE@%'))`,
            splitParam: true
        },
        {
            id: 'opsub_type',
            type: ATTR_TYPES.STRING,
            title: 'Typ vlastníka',
            values: [
                ['OFO', 'OFO'],
                ['OPO', 'OPO'],
                ['BSM', 'BSM'],
            ]
        },
        {
            id: 'address',
            type: ATTR_TYPES.STRING,
            title: 'Adresa',
            sqlField: `lower(obec || ' ' || COALESCE(nazev_ulice, ''))`,
            sqlWhere: `(lower(@FIELD@) LIKE lower('%@VALUE@%'))`,
            splitParam: true
        }
    ]
};

export {
    DEFINITION_OPSUB
};
